import {ColFileStructure} from '@tj/tj-dmp-lib-api';

export interface EtlFileSourceInterface {
    code: string;
    name: string;
    exampleValues: string;
}

export class EtlFileSource implements EtlFileSourceInterface {
    code: string;
    exampleValues: string;
    name: string;

    constructor(col: ColFileStructure) {
        this.code = col.code;
        this.name = col.name;
        if (col.exampleValues) {
            this.exampleValues = col.exampleValues.join(', ');
        }
    }
}
